interface SettlementGame {
  isBooted: boolean;
  input?: {
    mouse?: {
      target: Pick<EventTarget, 'removeEventListener'> | null;
      // Phaser declares this callback as Function; narrow it at the DOM boundary.
      onMouseWheel: unknown;
    } | null;
  };
  events: { once: (event: 'boot', callback: () => void) => unknown };
  destroy: (removeCanvas: boolean) => void;
}

/** Release the pooled canvas listener omitted by Phaser 3.90 MouseManager.destroy. */
export function destroySettlementGame(game: SettlementGame): void {
  const removeWheel = () => {
    const mouse = game.input?.mouse;
    if (mouse?.target && typeof mouse.onMouseWheel === 'function')
      mouse.target.removeEventListener('wheel', mouse.onMouseWheel as EventListener);
  };
  if (game.isBooted) removeWheel();
  // A cancelled mount can request destruction before Phaser boots its input managers.
  // Their earlier BOOT listeners install input before this callback; destruction then
  // runs on the next game frame, following Phaser's normal lifecycle.
  else game.events.once('boot', removeWheel);
  game.destroy(true);
}
